module.exports = __webpack_public_path__ + "static/media/designerIcon.65808f1a.svg";